class StateAccordionGroup extends HTMLElement {
  connectedCallback() {
    this.addEventListener('toggle', this.handleToggle, true);
  }

  disconnectedCallback() {
    this.removeEventListener('toggle', this.handleToggle, true);
  }

  handleToggle = (event) => {
    const target = event.target;
    if (target.tagName !== 'DETAILS' || !target.open) return;
    this.querySelectorAll('details').forEach((details) => {
      if (details !== target) details.open = false;
    });
  };
}

if (!customElements.get('state-accordion-group')) {
  customElements.define('state-accordion-group', StateAccordionGroup);
}
